import { buildSrcSet } from "@/lib/image";

// Drop-in replacement for <img> that adds a responsive srcset so mobile
// devices don't download the same desktop-sized image as desktop.
export const ResponsiveImg = ({ src, widths, sizes = "100vw", alt, className, loading = "lazy", fetchPriority }) => {
  const srcSet = buildSrcSet(src, widths);
  return (
    <img
      src={src}
      srcSet={srcSet}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
    />
  );
};
